module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0115-0b7f1820024cd05efd1a7adb9e49de7f.png";